
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { ProductWithPrice } from 'types';
import AgentCapabilities from '@/components/agents/AgentCapabilities';
import AgentChannels from '@/components/agents/AgentChannels';
import AgentLifecycle from '@/components/agents/AgentLifecycle';
import AgentPersonas from '@/components/agents/AgentPersonas';
import AgentsHero from '@/components/agents/AgentsHero';
import BotFeaturesVideo from '@/components/BotFeaturesVideo';
import BotPricing from '@/components/bots/BotPricing';
import CallToAction from '@/components/CallToAction';
import UseCasesSection from '@/components/chatbots/UseCasesSection';
import ActionsSection from '@/components/landing/ActionsSection';
import Footer from '@/components/layout/Footer';
import LogosCloud from '@/components/LogosCloud';
import Seo from '@/components/Seo';
import Testimonials from '@/components/Testimonials';
import { products_for_free_plan } from '@/constants/common';
import { createClient } from '@/utils/supabase/component';
import { useUser } from '@/utils/useUser';
// import Banner from '@/components/atoms/Banner'; // Black Friday is over
export default function ChatBots() {
    const { t } = useLocale('chatbots');
    const pricingT = useLocale('pricing').t;
    const [products, setProducts] = useState<ProductWithPrice[]>([]);
    const supabaseClient = createClient();
    const { isFreePlan } = useUser();
    useEffect(() => {
        const productsForPlan = products_for_free_plan.filter((id) => id !== 'prod_OqT3UM05zlYR3V' && id !== 'prod_QskSrexOhYVHhJ');
        getProductsWithPricesInArray(productsForPlan).then((data) => {
            // @ts-ignore
            setProducts(data);
        });
    }, []);
    const getProductsWithPricesInArray = async (product_ids: string[]) => {
        const { data, error } = await supabaseClient
            .from('products')
            .select('*, prices(*)')
            .in('id', product_ids)
            .eq('prices.active', true)
            .order('metadata->index')
            .order('unit_amount', { foreignTable: 'prices' });
        if (error) {
            console.log(error.message);
            throw error;
        }
        return data || [];
    };
    const message = pricingT(`Create your own AI chatbots and train them on your data.`);
    return (<main>
      {/* The support chat bubble is mounted site-wide by SiteChatWidget (_app). */}
      {/* <Banner /> Black Friday is over */}
      <Seo templateTitle={t('AI Agents | Build Custom AI Agents Trained on Your Data')} description={t('Build AI agents trained on your data. Deploy to your website, WhatsApp, Slack — even phone calls. Support, sales, and lead generation, 24/7.')} image={`https://easy-peasy.ai/api/og-template?title=${t('AI Agents Trained on Your Data')}`}/>
      <AgentsHero />
      <LogosCloud />

      <AgentPersonas />
      <AgentLifecycle />
      <AgentCapabilities />
      <AgentChannels />
      <ActionsSection />
      <UseCasesSection />

      <div id='demo'>
        <BotFeaturesVideo />
      </div>

      {/* <MainFeatures />
        <Features2 /> */}

      {/* <Features /> */}
      {/* <Banner /> */}

      {/* <SpecialOfferPricing products={products} /> */}

      {products.length > 0 && (<BotPricing products={products} message={message} buttonText={isFreePlan ? 'Start' : 'Upgrade'}/>)}

      <Testimonials />
      {/* <SpecialOfferFaq /> */}
      {/* <ContactUs /> */}
      <CallToAction preset='bots'/>
      <Footer />
    </main>);
}

    async function __Next_Translate__getStaticProps__1a0cbfb648e__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chatbots/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb648e__ as getStaticProps }
  